import { Injectable } from '@angular/core';
import {TokenService} from "../auth/token.service";
import {NgbDatepickerI18n, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {TranslationWidth} from "@angular/common";

export const I18N_VALUES = {
  'nl': {
    weekdays: ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo'],
    months: ['Jan', 'Feb', 'Maa', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  },
  'fr': {
    weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
    months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
  }
  // other languages you would support
};

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  language: string;
  constructor(private TokenService: TokenService) {
    super();
    const tokenLanguage = this.TokenService.getLanguage();
    const normalizedLanguage = typeof tokenLanguage === 'string'
      ? tokenLanguage.toLowerCase().slice(0, 2)
      : '';
    this.language = Object.prototype.hasOwnProperty.call(I18N_VALUES, normalizedLanguage)
      ? normalizedLanguage
      : 'nl';
  }
  private get translations() {
    return I18N_VALUES[this.language] || I18N_VALUES.nl;
  }
  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    return this.translations.weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return this.translations.months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
